import React from 'react'
import '../assets/css/components/image-empty-state.css'

const ImageEmptyState = ({ src, imageProps, text, textProps }) => {
  return(
    <div className='image-empty-state'>
      <img src={src} {...imageProps}/>
      <div className='empty-text' {...textProps}>{text}</div>
    </div>
  )
}

export default ImageEmptyState
